import * as Sentry from "@sentry/react";

import { isReadingUrl, sanitizeReadingEvent, sanitizeReadingBreadcrumb } from "../shared/reading-privacy";
const readingActive = () => isReadingUrl(window.location.href);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_COMMIT,
  // Only report in production builds
  enabled: import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    // maskAllText off: quiz content is non-sensitive vocabulary; seeing what the
    // child saw is the whole point of replay for audio/UI bug hunting
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false, block: [".reading-root"], networkDetailDenyUrls: [/\/api\/reading\//], beforeAddRecordingEvent: event => readingActive() ? null : event }),
  ],
  // 100% sampling everywhere — tiny user base (a handful of families), so full
  // visibility costs nothing and every event matters
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: readingActive() ? 0 : 1.0,
  replaysOnErrorSampleRate: readingActive() ? 0 : 1.0,
  enableLogs: true,
  tracePropagationTargets: [/^\/api\//],
  // Collect IP / user-agent so you can correlate audio bugs to devices/browsers
  sendDefaultPii: true,
  beforeSend: event => sanitizeReadingEvent(event, readingActive()),
  beforeSendTransaction: event => readingActive() || isReadingUrl(event.transaction ?? "") ? null : event,
  beforeBreadcrumb: crumb => sanitizeReadingBreadcrumb(crumb, readingActive()),
  beforeSendLog: log => readingActive() ? null : log,
});

export { Sentry };

// Reading has no replay session. Restart normal quiz replay only after leaving reading.
let replayTransition = Promise.resolve();
export function syncReadingReplay() {
  const reading = readingActive();
  replayTransition = replayTransition.then(async () => {
    const replay = Sentry.getReplay();
    if (!replay) return;
    if (reading) await replay.stop();
    else replay.start();
  }).catch(() => {});
}
